import { render, staticRenderFns } from "./EmrScreeningOPD.vue?vue&type=template&id=700a9d50&"
import script from "./EmrScreeningOPD.vue?vue&type=script&lang=js&"
export * from "./EmrScreeningOPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports